// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3cf3759e","453":"87a83ea7","732":"91e984a5"}[chunkId] + ".chunk.js";
};